var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4295 19.0736C36.4295 17.5823 36.306 16.494 36.0388 15.3655H18.6621V22.0965H28.8618C28.6563 23.7692 27.5458 26.2883 25.0781 27.9811L25.0435 28.2064L30.5377 32.3776L30.9183 32.4148C34.4141 29.2508 36.4295 24.5954 36.4295 19.0736Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.661 36.8083C23.658 36.8083 27.853 35.196 30.9171 32.415L25.0769 27.9812C23.5141 29.0493 21.4165 29.7949 18.661 29.7949C13.7668 29.7949 9.61286 26.631 8.13211 22.2578L7.91507 22.2759L2.20215 26.6088L2.12744 26.8123C5.17089 32.7373 11.4224 36.8083 18.661 36.8083Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13309 22.2579C7.74238 21.1294 7.51626 19.9201 7.51626 18.6707C7.51626 17.4212 7.74238 16.212 8.11253 15.0835L8.10218 14.8431L2.31766 10.4407L2.1284 10.5289C0.874048 12.9876 0.154297 15.7486 0.154297 18.6707C0.154297 21.5929 0.874048 24.3537 2.1284 26.8124L8.13309 22.2579Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6611 7.54635C22.1364 7.54635 24.4806 9.0175 25.8174 10.2469L31.0406 5.24897C27.8327 2.32681 23.6581 0.533203 18.6611 0.533203C11.4224 0.533203 5.17091 4.60405 2.12744 10.5289L8.11159 15.0835C9.61291 10.7104 13.7668 7.54635 18.6611 7.54635Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleicon);
export default __webpack_public_path__ + "static/media/googleicon.48f7ad277e27879f0a23064c70dfd495.svg";
export { ForwardRef as ReactComponent };